import React, {PropsWithChildren} from 'react';
import {LayoutComponent} from '../../components/Layout';
import {MobileHeader} from './header';

export const MobileLayout: React.FC<PropsWithChildren> = ({children}) => {
  return <LayoutComponent header={<MobileHeader />}>{children}</LayoutComponent>;
};
